<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  required,
} from "vuelidate/lib/validators";

export default {
  page: {
    title: "Ödeme Al",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
        list: {},
        title: "ÖDEME AL",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "ÖDEME AL",
            active: true,
          },
        ],
        isLoading: false,
        query:null,
        submitted:false,
        rows: [],
    };
  },
  mounted() {
     this.rows = [
        {id:1,name:'asrda',username:'serdar',status:'Aktif'},
        {id:2,name:'asrdsa',username:'serddar',status:'Aktif'}
    ]
  },
  validations: {
    query: { required },
  },
  methods: {
    existCustomer(){
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.$http.post('test', { ...this.query })
        .then(() => {
        })
        .catch(error => error)
      }
      this.submitted = false;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="existCustomer">
              <div class="row">
                <label class="col-sm-4 col-form-label">Müşteri Tc / Vkn / Pasaport Numarası</label>
                <div class="col-md-4">
                  <div class="mb-3">
                    <input
                      id="tcvkn"
                      v-model="query"
                      type="text"
                      class="form-control"
                      placeholder="Tc / Vkn / Pasaport Numarası"
                      :class="{
                        'is-invalid': submitted && $v.query.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.query.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.query.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-auto">
                  <button class="btn btn-primary" type="submit">Sorgula</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
            <table>
              <thead>
                <tr>
                  <td>asd</td>
                </tr>
              </thead>
            </table>
        </div>
      </div>
    </div>
  </Layout>
</template>